<template>
  <button type="submit" :class="buttonStyle({ disabled: props.disabled })" :disabled="props.disabled" @click.prevent="props.onClick">
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';
interface Props {
  disabled?: boolean;
  onClick: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const buttonStyle = tv({
  base: `h-[50px] w-full min-w-[120px] rounded-[1px] border border-solid border-black1 duration-300 hover:border-gray2`,
  variants: {
    disabled: {
      true: 'cursor-default border-gray2 bg-gray1 text-gray2',
    },
  },
});
</script>
